export default __webpack_public_path__ + "static/media/prenotaCart.863c1ba0.png";